import { Language } from 'js/vue/stores/languages/languagesStore';
import { AssignedStaffLabel } from 'api/settings/assignedStaffLabelsService';

export interface CustomTag {
    description: string;
    category: string;
    name: string;
}
export interface UILang {
    id: string;
    label: string;
}

//todo utiliser le type qui sera mep avec les acomptes
export enum DocumentType {
    INVOICE = 'invoice',
    ESTIMATE = 'estimate',
    CREDIT_NOTE = 'credit-note',
    DEPOSIT = 'deposit',
    PROFORMA = 'proforma',
    QUOTE = 'quote',
    ORDER = 'order',
    DELIVERY_SLIP = 'delivery-slip',
    DELIVERY = 'delivery',
}

// --- API types (snake_case, matching API responses/payloads) ---
export interface ApiInvoicingSettingsMetadata {
    assigned_staff_labels: AssignedStaffLabel[];
    languages: Language[];
    custom_tags: CustomTag[];
    enforce_display_rules: boolean;
    forced_prefs: string[];
    ui_langs: UILang[];
}

// --- Component types (camelCase, used in Vue components) ---
export interface InvoicingSettingsMetadata {
    assignedStaffLabels: AssignedStaffLabel[];
    languages: Language[];
    customTags: CustomTag[];
    enforceDisplayRules: boolean;
    forcedPrefs: string[];
    uiLangs: UILang[];
}
